import ProductCard from "./ProductCard";
import styled from "theme/libs/styled";
import { useSelector } from "react-redux";

const ProductsWrapper = styled("div")`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 8px;
    row-gap: 32px;
    transition: width ${({ theme }) => theme.transitions.secondary};
    width: unset;

    ${({ theme }) => theme.above.tabletSm} {
        grid-gap: 12px;
        grid-template-columns: repeat(4, 1fr);
    }

    ${({ theme }) => theme.above.desktopSm} {
        grid-gap: 16px;
    }
`;

const ProductGrid = () => {
    const productsLength = useSelector(({ products }) => products.allProducts.length) || 32;
    return (
        <ProductsWrapper>
            {Array(productsLength)
                .fill(null)
                .map((_product, index) => (
                    <ProductCard key={index} />
                ))}
        </ProductsWrapper>
    );
};

export default ProductGrid;
